<template>
    <el-dialog
        :visible.sync="value"
        custom-class="pageRes-file-move"
        width="770px"
        :append-to-body="true"
        :modal-append-to-body="true"
        :close-on-click-modal="false"
    >
        <div slot="title" class="file-header">
            <h3>{{titleTxt}}</h3>

            <el-input class="filter-name" v-model="fileName"
                      @keyup.enter.native="queryFolderByName"
                      placeholder="搜索文件夹" size="mini" clearable>
                <el-button slot="append" @click="queryFolderByName" icon="el-icon-search"></el-button>
            </el-input>
        </div>

        <div class="file-path">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="item in realList" :key="item.id"><a
                    @click="backFolder(item)"><span>{{ item == '' ? $t('res.allFiles') : item }}</span></a>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <ul class="file-list">
            <li class="file-item-wrap"
                v-for="item in folderList"
                :key="item.id">
                <div class="file-item"
                     @click="openFolder(item)"
                     :class="{'disabled': ids.includes(item.id)}"
                >
                    <div class="folder"></div>
                    <div class="file-name">{{item.name}}</div>
                </div>
            </li>
        </ul>

        <div slot="footer" class="file-action">
            <el-button @click="createFolder" size="medium">
                <i class="nucfont inuc-folder"></i> 新建文件夹
            </el-button>
            <el-button type="primary" @click="save" :loading="saveLoading" size="medium">{{btnTxt}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    components: {},

    props: {
        // 打开/关闭dialog，直接用v-model即可
        value: {
            type: Boolean,
            default: false,
        },
        // 源文件的id数组
        ids: {
            type: Array
        },
        type: {
            default: 1,   // 类型 1复制 2移动
        }
    },

    data() {
        return {
            saveLoading: false,
            folderList: [],
            fileName: '',
            realList: [''],
            realListPath: ''
        }
    },

    computed: {
        titleTxt() {
            return this.type === 1 ? '打开要复制的目标文件夹': '打开要移动的目标文件夹'
        },
        btnTxt() {
            return this.type === 1 ? '复制到这里': '移动到这里'
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog()
            } else {
                this.$emit('input', false)
                this.$parent.isOperating = false
            }
        },
    },

    methods: {
        initDialog() {
            this.fileName = ''
            this.realList = ['']
            this.realListPath = ''
            this.superiorID = ''

            this.queryFolders()
        },

        async queryFolders(data={}) {
            let queryData = {
                path: this.realListPath,
                types: 'Folder',
                ...data
            }

            let res = await this.$api.queryResourceTree(queryData)
            this.folderList = res.package;

            return this.folderList
        },

        queryFolderByName() {
            this.realListPath = ''
            this.realList = ['']

            this.queryFolders({
                name: this.fileName,
            })
        },

        createFolder() {
            this.$prompt(this.$t('res.folderNameTip'), '新建文件夹', {
                roundButton: true,
                //modal: false,
                customClass: 'notShowModal',
                inputValidator: value => {
                    if (!value.trim().length) {
                        return this.$t('res.folderNameTip')
                    }
                    if (value.trim().length > 50) {
                        return this.$t('rule.maxLength', ['50'])
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;

                        this.$api.queryResourceExistFolder({
                            name: instance.inputValue,
                            superiorID: this.superiorID
                        }).then(res => {
                            if (res.result) {
                                done();
                            }
                        }).finally(() => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = this.$t('c.confirm');
                        })
                    } else {
                        done();
                    }
                },
            }).then(({value}) => {

                this.$api.creatResourceFolder({
                    name: value,
                    superiorID: this.superiorID,
                }).then(res => {
                    this.$message.success('新建成功！')
                    this.queryFolders()
                })

            }).catch(() => {});
        },

        async openFolder(data) {
            // 禁止复制或移动到子目录下
            if (this.ids.includes(data.id)) return

            // 文件夹
            this.realListPath = data.path;
            this.realList = data.path.split('/');
            this.superiorID = data.id;

            await this.queryFolders()
        },

        async backFolder(path) {
            this.realListPath = this.realListPath.split('/' + path)[0] + '/' + path;

            if (path == '') {
                this.realList = [''];
            } else {
                this.realList = this.realListPath.split('/');
            }

            let list = await this.queryFolders()
            this.superiorID = list[0].superiorID;
        },

        async save() {
            let request = this.type === 1 ? this.$api.copyResource: this.$api.moveResource

            // 根目录为-1
            let superiorID = this.superiorID || -1
            this.saveLoading = true
            await request(superiorID, {sourceIDs: this.ids}).finally(() => this.saveLoading = false)

            this.$message.success('操作成功！')
            this.$emit('move-success')
            this.$emit('input', false)
        }
    },

}
</script>

<style lang="scss">
    .pageRes-file-move {
        overflow: hidden;

        .el-dialog__header {
            padding: 18px 60px 18px 30px;
            .el-dialog__headerbtn {
                top: 12px;
            }
        }
        .el-dialog__body {
            padding: 0;
        }
        .el-dialog__footer {
            padding: 15px 22px;
            box-shadow: 0 0 4px #ddd;
        }

        .file-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3 {
                font-size: 18px;
            }
            .filter-name {
                width: 220px;
            }
        }

        .file-path {
            padding: 10px 15px;
            background-color: #f9f9f9;
            border-bottom: 1px solid #efefef;
        }

        .file-list {
            display: flex;
            flex-wrap: wrap;
            height: 360px;
            padding: 10px;
            overflow: auto;
            .file-item-wrap {
                width: 20%;
            }
            .file-item {
                padding: 15px;
                margin: 0 9px 9px 0;
                height: 130px;
                border: 2px solid transparent;
                cursor: pointer;
                &:hover:not(.disabled) {
                    border-color: #2b91e3;
                }
                &.disabled {
                    cursor: not-allowed;
                    .file-name {
                        color: #999;
                    }
                }
            }
            .folder {
                position: relative;
                width: 80px;
                height: 80px;
                margin: 0 auto;
                background: url(~@/assets/images/map/folder.png) no-repeat center;
                background-size: contain;
            }
            .file-name {
                margin-top: 5px;
                font-size: 13px;
                text-align: center;
                @include no-wrap();
            }
        }

        .file-action {
            display: flex;
            justify-content: space-between;
        }
    }
</style>
